<template>
  <v-dialog v-model="open" max-width="700px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-card width="100%" class="rounded-0" color="indigo accent-3">
        <v-row justify="space-between" no-gutters>
          <v-col cols="11" v-bind="attrs" v-on="on" v-ripple>
            <v-row no-gutters>
              <v-col class="py-4 pl-4">
                <p class="text-subtitle-1 pt-1 my-0" style="color: white">{{ title }}</p>
              </v-col>
            </v-row>
          </v-col>

          <v-spacer />

          <v-col class="py-4 align-end mr-2">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  dark
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                    v-for="(item, key) in menuOptions"
                    :key="key"
                    link
                    v-on:click="() => onClickAction(key)"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>

                <v-divider class="my-2"/>

                <v-list-item v-on:click="() => onClickAction('DELETE')" link>
                  <v-list-item-title>Excluir seção e itens</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <v-card>
      <v-card-title>Nome da seção</v-card-title>

      <v-card-text>
        <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
        >
          <v-row no-gutters>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
                  label="Nome da seção"
                  v-model="formData.title"
                  :rules="titleRules"
                  required
                  dense
                  outlined
                  :counter="140"
                  v-on:keypress="keyPress"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LocationMenuSectionTitleModal",
  props: {
    title: String,
    action: {
      type: Function,
      required: true
    },
  },
  methods: {
    keyPress: function(e) {
      if (e.keyCode === 13) {
        e.preventDefault()
        this.callAction()
      }
    },
    onClickAction: function(value) {
      this.$emit('action', value)
    },
    cancel: function() {
      this.open = false
    },
    callAction: async function () {
      if (this.validate()) {
        this.loading = true
        await this.action(this.formData)

        if (this.clearOnSubmit) {
          this.formData = {
            title: ''
          }
        }
        this.open = false
        this.loading = false
      }
    },
    validate: function() {
      return this.$refs.form.validate()
    }
  },
  data: () => ({
    open: false,
    menuOptions: {
      'FIRST': 'Mover para o início',
      'UP': 'Mover para cima',
      'DOWN': 'Mover para baixo',
      'LAST': 'Mover para o fim'
    },
    loading: false,
    formValid: true,
    formData: {
      title: ''
    },
    titleRules: [
      v => !!v || 'O nome da seção é obrigatório',
      v => (v && v.length <= 140) || 'O nome da seção pode ter no máximo 140 caracteres',
    ]
  }),
  created() {
    this.formData = JSON.parse(JSON.stringify({
      title: this.title
    }))
  }
}
</script>

<style scoped>
.align-end {
  text-align: end;
}
</style>